module.exports = __webpack_public_path__ + "img/vue1-semelle_rouge.9c33e6a5.png";